import * as yup from 'yup';

import localizedStrings from 'localization';

export const addCohortSchema = yup.object().shape({
  questCode: yup
    .number()
    .required(localizedStrings.enrollmentCodeRequiredMessage),
});
